function cov_2pqjou4oun() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/core/AutocompleteInput/index.ts";
  var hash = "26acc1560eef7397cf15218a46ff8dceb36a6560";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/core/AutocompleteInput/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "26acc1560eef7397cf15218a46ff8dceb36a6560"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2pqjou4oun = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2pqjou4oun();
export { default } from "./AutocompleteInput.mjs";
//# sourceMappingURL=index.mjs.map